// export const baseUrl = "http://localhost:5052"
//export const baseUrl = "https://marn-blog-backend.herokuapp.com"

export const baseUrl = "https://blog-application-backend.onrender.com"

//export const baseUrl = "https://mern-blg-app-bcnd.herokuapp.com"

// export const baseUrl = "https://shankachur-bknd.herokuapp.com"





